import { CognitoJwtVerifier } from "aws-jwt-verify";

export function tokenToJson (token) {
  const bare = token.startsWith('Bearer ') ? token.slice(7) : token
  const b64 = bare.split('.')
  try {
    const json = atob(b64[1])
    return json
  }
  catch {
    return undefined
  }
}

export async function verifyCognitoJWT(jwt) {
  const onlyTok = jwt.startsWith('Bearer ') ? jwt.split(" ")[1] : jwt
  const json = JSON.parse(atob(onlyTok.split('.')[1]))
  const index = json?.iss?.lastIndexOf('aws.com/') ?? undefined
  let pool = undefined
  if (index) {
    pool = json.iss.substring(index+8)
  }
  const verifier = CognitoJwtVerifier.create({
    userPoolId: pool,
    tokenUse: json?.token_use,
    clientId: json?.aud,
  });
  let payload = undefined
  try {
    payload = await verifier.verify(onlyTok)
    // console.log("Token is valid. Payload:", payload);
  } catch {
    console.log("Token not valid!");
  }
  return payload
}
